export const messages = {
  en: {
    noticeDetail: {
      title: 'Notice Details',
      back: 'Back',
      titleLabel: 'Title',
      noticeType: 'Notice Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      content: 'Content',
      fetchError: 'Failed to fetch notice details'
    }
  },
  zh: {
    noticeDetail: {
      title: '公示详情',
      back: '返回',
      titleLabel: '标题',
      noticeType: '公示类型',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '创建时间',
      content: '公示内容',
      fetchError: '获取公示详情失败'
    }
  }
}